module.exports = __webpack_public_path__ + "img/refresh-icon.b24273d4.svg";